import React from 'react';
import type { ShowcasePopulatedItem } from 'root/apiTypes';
import { Item } from 'root/components/Menus/Item/Item';
import { classes, st } from './Items.st.css';
import { dataHooks } from 'root/dataHooks';
import { ItemsContextProvider } from 'root/contexts/ItemsContext';
import { useProvideItemsDisplayValues } from 'root/hooks/useItemsDisplayValues';
import { DesignedDivider } from 'root/components/Menus/DesignedDivider/DesignedDivider';
import type { DiscountByItemId } from '@wix/restaurants-normalizers';
import type { ItemsBehavior } from 'root/contexts/ItemsContext';

export const Items = ({
  isSectionCollapsed = false,
  items,
  sectionId,
  sectionTitleId,
  discountInfoByItemId,
  itemBehavior,
}: {
  items: ShowcasePopulatedItem[];
  sectionId: string;
  sectionTitleId: string;
  isSectionCollapsed?: boolean;
  discountInfoByItemId?: DiscountByItemId;
  itemBehavior?: ItemsBehavior;
}) => {
  const displayValues = useProvideItemsDisplayValues();

  return (
    <ItemsContextProvider value={{ sectionId, discountInfoByItemId, itemBehavior, displayValues }}>
      <div
        aria-labelledby={sectionTitleId}
        className={st(classes.itemsContainer, isSectionCollapsed ? classes.collapse : '')}
        data-hook={dataHooks.items.container}
        role="list"
      >
        {items.map((item, index) => (
          <React.Fragment key={item.id ?? index}>
            <div className={classes.dividerContainer} role="listitem">
              <DesignedDivider className={classes.divider} dividerName="itemDivider" />
            </div>
            <Item item={item} />
          </React.Fragment>
        ))}
      </div>
    </ItemsContextProvider>
  );
};
